<template>
  <div id="MakeD3Network" class="make-D3net" >
    <div>
        <p class="mb-0 text-center" style="font-size:30px;">共起ネットワーク</p>
        <p class="pl-6 mb-0" style="font-size:15px;">共起ネットワークとは、{{$t('アイデア')}}の単語同士の関連性や出現パターンの類似性を踏まえて文章中の単語の繋がりを可視化したものです。</p>
        <p class="pl-6 mb-0" style="font-size:15px;">単語間の共通点や相違点を評価したり、出現頻度の高い表現の把握や文全体の趣旨の理解などに役立ちます。</p>
    </div>
    <d3-network
      v-if="newNodes.length!==0"
      :net-nodes="newNodes"
      :net-links="newLinks"
      :options="options"
      :style="styles"
      class="make-D3net"
    ></d3-network>
    <div v-else style="display:flex; justify-content:center; align-items:center; height: 400px;">
      <p style="font-size:20px;">データが存在しないか、処理中です。</p>
    </div>
  </div>
</template>
 
<script>
import D3Network from "vue-d3-network";
//:fontSizeMapper="fontSizeMapper"
//v-show="isShow[trueorfalse]"
//:spiral="rectangular" or "archimedian"

//cloudWordsはデータ結果を入力する

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}

function getRandomColor(self){
    // //console.log("getRandomInt(0, 5) = ",getRandomInt(0, 5))
    return self.myColors[getRandomInt(0, 5)]
}

export default {
    name: 'MakeD3Network',
    props: {
        word_dict:{},
        width:String,
        height:String,
        words_list:{},
        idea:{},
        edge_dict:{},
        force: Number,
    },
    components: {
        D3Network,
    },
    data() {
        return {
            options: {
                force: this.force,
                forces: {X:0.5,Y:1.5},
                size:{h:Number(this.height.replace("px",""))-50},
                nodeSize: 15,
                fontSize: 15,
                nodeLabels: true,
                linkWidth: 1,
                canvas: this.canvas
            },
            newNodes: [],
            newLinks: [],
            myColors: ["rgba(56,141,247,0.5)","rgba(242,162,85,0.5)","rgba(213,82,85,0.5)","rgba(88,147,80,0.5)", "#66BAFC"],
        }
    },
    created() {
        //console.log(this.edge_dict)
        //console.log(Object.keys(this.edge_dict).length)
        // //console.log(this.idea)
        this.newNodes = [];
        let nodeList=[]
        let edgeList=[]

        for (let edge_str in this.edge_dict){
            let edge_str_2 = edge_str.slice(1,-1)
            //console.log(edge_str)
            let edge = edge_str_2.split(',')
            //console.log(edge)
            let j = Number(edge[0]);
            let k = Number(edge[1]);
            const isWord = (x) => this.words_list[x] && !Number(this.words_list[x]) && this.words_list[x] !== 'WS';
            if (isWord(j) && isWord(k)){
                nodeList.push(j);
                nodeList.push(k);
                if (this.edge_dict[edge_str]<=5){
                    this.newLinks.push({ sid: j, tid: k, _color: "rgba(232,203,118,0.7)"  })
                }else if (this.edge_dict[edge_str]<=10){
                    this.newLinks.push({ sid: j, tid: k, _color: "red"  })
                }else{
                    this.newLinks.push({ sid: j, tid: k, _color: "rgba(170,0,0,0.7)"  })
                }
            }
        }
        //console.log(nodeList.length)
        let seted_nodeList = new Set(nodeList);
        let setToArr_nodeList = Array.from(seted_nodeList);
        //console.log(setToArr_nodeList)
        for (let i in setToArr_nodeList){
            //console.log(setToArr_nodeList[i])
            let node = setToArr_nodeList[i]
            //console.log(this.words_list[node])
            if (this.word_dict[this.words_list[node]] >=5){
                this.newNodes.push({ id: node, name: this.words_list[node], _color: "blue"  })
            }else{
                this.newNodes.push({ id: node, name: this.words_list[node], _color: this.myColors[4]  })
            }
            
        }
        
        // //console.log(this.newLinks)
        //console.log("sasa",this.edge_dict)
    },
    methods:{
    },
    computed: {
    // バインドするスタイルを生成
        styles () {
            return {
                '--height': this.height,
                '--width': this.width,
            }
        }
    },
}
</script>
<style scoped>
.make-D3net{
    --width: 100%;
    /*--height: 400px;*/
    height: var(--height);
    width: var(--width);
    left: 10;
}
/* text:hover { 
    opacity: .6 !important; 
    font-size: 200% !important;
    font-weight: bold !important;
} */
/* div.tooltip {
    position: absolute;
    width: 140px;
    height: 80px !important;
    padding: 8px;
    font: 18px Arial;
    line-height: 24px;
    color: black !important;
    background: whitesmoke !important;
    border: 0px;
    border-radius: 10px !important;
    pointer-events: none;
} */
/* container{
  font-family: 'PT Sans', sans-serif;
  background-color: #eee;
} */
</style>